var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useMemo } from 'react';
import { stripUndefinedValues } from '../../helpers/utils';
const defaultConfig = {
    socialCommunityCreationButtonVisible: true,
    showCreatePublicCommunityOption: false,
    showUserProfileMetadata: false,
    showOldStyleComments: false,
    showCreateCommunity: false,
    manateeUrl: null,
    dashboardUrl: null,
    isUserCurrentlyInStingDashCallback: (_uac) => __awaiter(void 0, void 0, void 0, function* () { return false; }),
    addCoachNoteCallback: (_uac, _userLocale, _note) => __awaiter(void 0, void 0, void 0, function* () { return false; }),
    transferUserToStingCallback: (_uac, _userLocale, _message) => __awaiter(void 0, void 0, void 0, function* () { return false; }),
    fetchNextPostInCommunity: (_cid, _pid, _dir) => __awaiter(void 0, void 0, void 0, function* () { return ''; }),
};
const ConfigContext = createContext(defaultConfig);
export const useConfig = () => useContext(ConfigContext);
export default ({ children, config }) => {
    const value = useMemo(() => (Object.assign(Object.assign({}, defaultConfig), stripUndefinedValues(config))), [config]);
    return React.createElement(ConfigContext.Provider, { value: value }, children);
};
//# sourceMappingURL=ConfigProvider.js.map